import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

const API_ENDPOINT = 'api/';

@Injectable({
  providedIn: 'root',
})
export class ApiNewsletterService {

  /**
   * Constructor
   *
   * @param {HttpClient} http
   */
  public constructor(private http: HttpClient) {
  }

  public addContact(email: string) {
    return this.http.post(API_ENDPOINT + 'newsletter/post/add_new_address', {
      email,
    })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
          return throwError(error);
        },
      ),
    );
  }

}
